import React from 'react';
import CopyButton from './CopyButton';
import './CodeBlock.css';

interface CodeBlockProps {
  code: string;
  className?: string;
}

export default function CodeBlock({ code, className = '' }: CodeBlockProps) {
  return (
    <div className={`code-block ${className}`.trim()}>
      <CopyButton text={code} className="code-block-copy" />
      <pre className="code-block-pre">
        <code>{code}</code>
      </pre>
    </div>
  );
}
